import clsx from 'clsx'
import { ComponentProps, FC } from 'react'

export const RequiredAsterisk: FC<Omit<ComponentProps<'span'>, 'children'>> = (props) => <span {...props} className={clsx('i-fx txt-negative-600', props.className)}>*</span>
